import { constants } from "../../../constants";
export default class CloseGame {
    constructor(gb) {
        Object.assign(this, { gb });
   }
    GREENTUBE_handler() {
        if (!this.gb.queryParams.freeRounds) {
           this.gb.emitters.emit.web.closeGame();
        }
    }

    EVOUTION_handler() {
        if (this.gb.walletProtocol === constants.ORYX) {
            const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
            if (isIOS) {
                this.gb.emitters.emit.web.customMsg({"event":"CLOSE"});
            } else {
                this.gb.emitters.emit.web.closeGame();
            }
        } else {
            return;
        }
    }

    SH_handler(payload) {
        if (payload && payload.value === "lobby") {
            this.gb.emitters.emit.web.closeGame();
        }
    }

    HBN_handler(data) {
        if (data.url) {
            this.gb.queryParams.lobbyUrl = data.url;
        }

        this.gb.emitters.emit.web.closeGame();
    }

    SPINOMENAL_handler(data) {
        if (data.data.type && data.data.type === 'home') {
            this.gb.emitters.emit.web.closeGame();
        }
    }
    HABANERO2_handler(data) {
        if (data.url) {
            this.gb.queryParams.lobbyUrl = data.url;
        }
        this.gb.emitters.emit.web.closeGame();
    }

    _default(data) {
        this.gb.emitters.emit.web.closeGame(data);
    }

    exposeEvent() {
        let event = {
            close: this._default,
        };

        switch (this.gb.gameProviderProtocol) {
            case constants.GREENTUBE:
                event["gameClosing"] = this.GREENTUBE_handler;
                break;
            case constants.PRAGMATIC_PLAY:
                event["gameQuit"] = this._default;
                break;
            case constants.F1X2:
                event["game-close"] = this._default;
                break;
            case constants.SLINGO:
                event["showLobby"] = this._default;
                break;
            case constants.IGT:
                event["rgs2custCloseGame"] = this._default;
                break;
            case constants.PNG:
                event["logout"] = this._default;
                break;
            case constants.MGS:
                event["launchlobby"] = this._default;
                break;
            case constants.THUNDER:
                event["backtolobby"] = this._default;
                break;
            case constants.AMATIC:
                event["exit"] = this._default;
                break;
            case constants.EGT:
                event["com.egt-bg.exit"] = this._default;
                break;
            case constants.EDICT:
                event["notifyCloseContainer"] = this._default;
                break;
            case constants.EZUGI:
                event["close_game"] = this._default;
                break;
            case constants.BP:
                event["closeGame"] = this._default;
                break
            case constants.GSPOKER:
                event["gameCompleted"] = this._default;
                break;
            case constants.EVOLUTION:
                event["RETURN_HOME"] = this.EVOUTION_handler;
                break;
            case constants.SH:
                event["navigate"] = this.SH_handler;
                break;
            case constants.BGS:
            case constants.RAW:
            case constants.RGU:
            case constants.HB:
                event["showLobby"] = this._default;
                break;
            case constants.DGC:
                event["gel.close"] = this._default;
                break;
            case constants.QS:
            case constants.RELAX:
                event["gprg_UserAction"] = this._default;
                break;
            case constants.FAZI:
                event["game.ended"] = this._default;
                break;
            case constants.WD:
                event["WGEAPI.closeGame"] = this._default;
                break;
            case constants.STAKELOGIC2:
                event["CLOSE"] = this._default;
                event["HOME"] = this._default;
                break;
            case constants.SPRIBE:
                event["ifc.close"] = this._default;
                event["ifc.back.to.home"] = this._default;
                break;
            case constants.SYN:
                event["g2p.gameClosing"] = this._default;
                break;
            case constants.KAJ:
                event["game.end"] = this._default;
                break;
            case constants.ISOFT:
                event["GAME_CLOSED"] = this._default;
                break;
            case constants.RST:
                event["exit"] = this._default;
                break;
            case constants.PT:
                event["ucip.gameinstance.g2wGameCloseNotification"] = this._default;
                break;
            case constants.NLC:
                event["exit"] = this._default;
                break;
            case constants.YGG:
                event["game/sessionClosed"] = this._default;
                break;
            case constants.HBN:
                event["gameClose"] = this._default;
                event["gotoLobby"] = this.HBN_handler;
                // event["doGameSuspend"] = this.HBN_handler;
                break;
            case constants.ENDOR:
                event["closeGame"] = this._default;
                event["gameExit"] = this._default;
                break;
            case constants.SPIN:
                event["lobby"] = this._default;
                break;
            case constants.PLS:
                event["unloading"] = this._default;
                break;
            case constants.GDR2:
                event["game.goto.home"] = this._default;
                break;
            case constants.SPINOMENAL:
                event["linkRedirect"] = this.SPINOMENAL_handler;
                break;
            case constants.HKS:
                event["onNavigateTo"] = this._default;
                break;
            case constants.EDIG:
                event["exit"]= this._default;
                break;
            case constants.ORYX:
                event["close"]= this._default;
                event["gameClose"] = this._default; // mapped specifically for GAMOMAT
                break;
            case constants.T4B:
                event["game.end"] = this._default;
                break;
            case constants.EYE:
                event["gameClose"] = this._default;
                break;
            case constants.HNR:
                event["gameClose"] = this._default;
                event["gotoLobby"] = this.HABANERO2_handler;
                break;
            case constants.OAK:
                event["player_exit"] = this._default;
                break;
            case constants.BSFT:
                event["exi_onManagedAppLeave"] = () => {};
                event["exi_onManagedAppLeaving"] = () => {};
                event["exi_onHomeUserAction"] = this._default;
                break;
            case constants.PATE:
                event["exit"] = this._default;
                event["close"] = this._default;     // Pateplay should implement our default game events API soon, so this is registered as well.
                event["gameClose"] = this._default; // Pateplay should implement our default game events API soon, so this is registered as well.
                break;
            default:
                event["close"] = this._default;
                event["gameClose"] = this._default;
        }

        return event;
    }
}
